/* eslint new-cap: ["error", { "capIsNewExceptions": ["DragDropContext"] }] */

import React from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

class ReorderableList extends React.Component {
  render() {
    return (
      <ul style={this.props.style} className={this.props.className}>
        {this.props.children}
      </ul>
    );
  }
}

export default DragDropContext(HTML5Backend)(ReorderableList);
